import { useQuery } from 'react-query';
import request from '../../../../../../helpers/request';

const pathSegments = {
  masters: 'workers',
  executers: 'executers',
};

const workersKey = ({ pathSegment, houseId, serviceId, isWarranty }) => [
  'warranty_workers',
  pathSegment,
  houseId,
  serviceId,
  isWarranty,
];

const texts = {
  [pathSegments.masters]: 'мастеров',
  [pathSegments.executers]: 'исполнителей',
};

const fetchWorkers = async ({ queryKey }) => {
  const [_, pathSegment, houseId, serviceId, isWarranty] = queryKey;

  return await request.get(
    `/Request/${pathSegment}`,
    { houseId, serviceId, isWarranty },
    `Не удалось загрузить список ${texts[pathSegment]}`
  );
};

const useWorkers = (params, options) =>
  useQuery(workersKey(params), fetchWorkers, options);

export { pathSegments, workersKey, useWorkers };
